import Vue from 'vue'

export default Vue.extend({
  computed: {
    schedulingConflicts(): boolean {
      return this.errors.some((e: any) => e.errcode == '23P01')
    },
    hasErrors(): boolean {
      return this.errors.length > 0
    },
  },
  data(): { errors: any[] } {
    return { errors: [] }
  },
  methods: {
    reset() {
      this.errors = []
    },
    catchError(error) {
      this.errors.push(error)
    },
  },
})
